export default __webpack_public_path__ + "static/favicon-7f1e5072c3e45114706d3447f8d134bb.png";